import { DocumentReference } from "firebase/firestore";

export default class AnaliseInteligenteMensal implements IRelatorioMensal {
  public ref!: DocumentReference<AnaliseInteligenteMensal>;
  public introducao!: string;
  public resultados!: string;
  public carteira!: string;
  public proventos!: string;
  public conclusao!: string;

  constructor(param: IRelatorioMensal) {
    Object.assign(this, param);
  }

  static fromJson(
    ref: DocumentReference<AnaliseInteligenteMensal>,
    relatorio: Omit<IRelatorioMensal, "ref">
  ): AnaliseInteligenteMensal {
    return new AnaliseInteligenteMensal({
      ref,
      ...relatorio,
    });
  }
}

interface IRelatorioMensal {
  ref: DocumentReference<AnaliseInteligenteMensal>;
  introducao: string;
  resultados: string;
  carteira: string;
  proventos: string;
  conclusao: string;
}
